import { ResponsiveBar } from "@nivo/bar";
import { Box } from "@mui/material";

const ComparisonBarChart = ({ comparison }) => {
    if (!comparison) return null;

    const data = [
        {
            metric: "Poziom PRK",
            Użytkownik: comparison.prkUser,
            Średnia: comparison.prkAverage,
        },
        {
            metric: "Liczba odznak",
            Użytkownik: comparison.badgesUserTotal,
            Średnia: comparison.badgesAverage,
        },
    ];

    return (
        <Box sx={{ height: 300 }}>
            <ResponsiveBar
                data={data}
                keys={["Użytkownik", "Średnia"]}
                indexBy="metric"
                margin={{ top: 30, right: 30, bottom: 50, left: 60 }}
                padding={0.3}
                groupMode="grouped"
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={({ id }) =>
                    id === "Użytkownik" ? "#294e6b" : "#6cc6d9"
                }
                borderRadius={4}
                borderWidth={1}
                borderColor={{ from: "color", modifiers: [["darker", 0.3]] }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    legend: "",
                    legendPosition: "middle",
                    legendOffset: 32,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    legend: "Wartość",
                    legendPosition: "middle",
                    legendOffset: -40,
                }}
                enableLabel={true}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor="#ffffff"
                animate={true}
                role="application"
            />
        </Box>
    );
};

export default ComparisonBarChart;
